import { MapUtils } from '../../../utility/map-utils.js';
import { cloneData, isSameData } from '../../dto/data-model-utils.js';
import {
  DataModel, DataModelBuilder, SerializationContext, SerializedData,
} from '../../dto/data-model.js';
import { SeatingOptions } from '../seating-options.js';

export abstract class SeatedOpenAccessProtocolModifier extends DataModel {}

export class AddEventToSeatedOpenAccessProtocol extends SeatedOpenAccessProtocolModifier {
  static readonly TYPE_ID: string = 'f8c6f1f070934635adf6f9afba340077';

  private constructor(
    public readonly eventId: string,
    public readonly seatingOptions: SeatingOptions,
  ) {
    super();
  }

  get $typeId(): string {
    return AddEventToSeatedOpenAccessProtocol.TYPE_ID;
  }

  static create(args: {
    eventId: string,
    seatingOptions: SeatingOptions,
  }): AddEventToSeatedOpenAccessProtocol {
    return new AddEventToSeatedOpenAccessProtocol(
        args.eventId,
        args.seatingOptions,
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): AddEventToSeatedOpenAccessProtocol {
    return this.create({
      eventId: MapUtils.getString(map, 'eventId'),
      seatingOptions: context.fromData(MapUtils.getRecord(map, 'seatingOptions')),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      eventId: this.eventId,
      seatingOptions: context.toData(this.seatingOptions),
    };
  }

  clone(): this {
    return AddEventToSeatedOpenAccessProtocol.create({
      eventId: this.eventId,
      seatingOptions: cloneData(this.seatingOptions),
    }) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.eventId === this.eventId &&
      isSameData(other.seatingOptions, this.seatingOptions);
  }
}

export class AddEventToSeatedOpenAccessProtocolBuilder extends DataModelBuilder<AddEventToSeatedOpenAccessProtocol> {
  build(context: SerializationContext, map: SerializedData): AddEventToSeatedOpenAccessProtocol {
    return AddEventToSeatedOpenAccessProtocol.fromMap(context, map);
  }
}

export class RemoveEventFromSeatedOpenAccessProtocol extends SeatedOpenAccessProtocolModifier {
  static readonly TYPE_ID: string = '21d7459ed68e470fb8e674954b69ac33';

  private constructor(
    public readonly eventId: string,
  ) {
    super();
  }

  get $typeId(): string {
    return RemoveEventFromSeatedOpenAccessProtocol.TYPE_ID;
  }

  static create(args: {
    eventId: string,
  }): RemoveEventFromSeatedOpenAccessProtocol {
    return new RemoveEventFromSeatedOpenAccessProtocol(
        args.eventId,
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): RemoveEventFromSeatedOpenAccessProtocol {
    return this.create({
      eventId: MapUtils.getString(map, 'eventId'),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      eventId: this.eventId,
    };
  }

  clone(): this {
    return RemoveEventFromSeatedOpenAccessProtocol.create({
      eventId: this.eventId,
    }) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.eventId === this.eventId;
  }
}

export class RemoveEventFromSeatedOpenAccessProtocolBuilder extends DataModelBuilder<RemoveEventFromSeatedOpenAccessProtocol> {
  build(context: SerializationContext, map: SerializedData): RemoveEventFromSeatedOpenAccessProtocol {
    return RemoveEventFromSeatedOpenAccessProtocol.fromMap(context, map);
  }
}
